/**
 * Matching Engine Admin Cohort Snapshot schema
 *
 * Wire contract for the admin UI's cohort drill-down:
 *   GET /api/v1/admin/events/:eventIdPublic/matching-engine/runs/:runIdPublic/cohort
 *
 * The third read alongside the run snapshot (which carries the run and its
 * progress, and nothing a step produced) and the participant snapshot (which
 * carries one person's rows). A cohort step's document names no person, so it
 * appears in neither — this is where it surfaces.
 *
 * `stepResults` is the canonical domain union verbatim, exactly as the
 * participant snapshot carries its own: no curated allow-list, so a second
 * cohort step type surfaces here with no change to this schema.
 */

import { z } from "zod";
import { MatchingEngineStepResultSchema } from "./matching-engine-step-result.schemas.js";

export const MatchingEngineCohortSnapshotSchema = z.object({
  stepResults: z.array(MatchingEngineStepResultSchema),
});

export type MatchingEngineCohortSnapshot = z.infer<
  typeof MatchingEngineCohortSnapshotSchema
>;
